import React from "react";
import {hidePreloader} from "../../library/helper";

export default function SessionExpired() {
    React.useEffect(() => {
        hidePreloader();
        const t = setTimeout(() => {
            const redirectUrl = [
                process.env.REACT_APP_ACCOUNT_URL,
                '/login?',
                `redirect_=${encodeURIComponent(window.location.href)}`
            ].join('');
            window.location.assign(redirectUrl);
        }, 2500); // ⏳ 2.5s soft pause
        return () => clearTimeout(t);
    }, []);

    return (
        <div
            style={{
                position: "relative",
                height: "100vh",
                overflow: "hidden",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: "linear-gradient(180deg, #F5FBF9 0%, #FFFFFF 100%)",
            }}
        >
            <div
                className="p-4 text-center shadow-lg"
                style={{
                    background: "linear-gradient(180deg, #F5FBF9 0%, #FFFFFF 100%)",
                    borderRadius: 16,
                    border: "1px solid #E6F0EC",
                    maxWidth: 480,
                    margin: "0 auto",
                }}
            >
                <p className="fw-bold" style={{ fontSize: "1.5rem", lineHeight: 1.4, marginBottom: "0.75rem", color: "#0A564B" }}>
                    Session expired
                </p>
                <p style={{ fontSize: "0.95rem", marginBottom: "1.25rem", color: "#111827" }}>
                    Please log in again. We’re redirecting you shortly…
                </p>
            </div>
        </div>
    );
}
